// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateTeamMarketingProfileSlug(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ProfileSettingsChangedError",
    "TeamMarketingProfileSlugUpdated"
  ]);
}

let variablesConverter = {"updateTeamMarketingProfileSlugInput":{},"__root":{"input":{"r":"updateTeamMarketingProfileSlugInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateTeamMarketingProfileSlug_TeamMarketingProfileSlugUpdated_marketingProfile_publicUrl":{"b":""},"updateTeamMarketingProfileSlug_TeamMarketingProfileSlugUpdated_marketingProfile":{"f":""},"updateTeamMarketingProfileSlug":{"u":"response_updateTeamMarketingProfileSlug"}}};

let wrapResponseConverterMap = {
  response_updateTeamMarketingProfileSlug: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateTeamMarketingProfileSlug_TeamMarketingProfileSlugUpdated_marketingProfile_publicUrl":{"b":""},"updateTeamMarketingProfileSlug_TeamMarketingProfileSlugUpdated_marketingProfile":{"f":""},"updateTeamMarketingProfileSlug":{"u":"response_updateTeamMarketingProfileSlug"}}};

let responseConverterMap = {
  response_updateTeamMarketingProfileSlug: unwrap_response_updateTeamMarketingProfileSlug
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "settingsChangedMessage",
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ProfileSettingsChangedError",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamMarketingProfileSlugFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateTeamMarketingProfileSlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TeamMarketingProfileSlugForm_form_agentMarketingProfile"
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileSlugUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamMarketingProfileSlugFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateTeamMarketingProfileSlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketingProfileURLDetails",
                    "kind": "LinkedField",
                    "name": "urlDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "baseUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileSlugUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "91d3e6298413e84445d30e07961a9fb4",
    "id": null,
    "metadata": {},
    "name": "TeamMarketingProfileSlugFormMutation",
    "operationKind": "mutation",
    "text": "mutation TeamMarketingProfileSlugFormMutation(\n  $input: UpdateTeamMarketingProfileSlugInput!\n) {\n  updateTeamMarketingProfileSlug(input: $input) {\n    __typename\n    ... on ProfileSettingsChangedError {\n      settingsChangedMessage: message\n    }\n    ... on TeamMarketingProfileSlugUpdated {\n      marketingProfile {\n        ...TeamMarketingProfileSlugForm_form_agentMarketingProfile\n        publicUrl\n        nodeId\n      }\n    }\n  }\n}\n\nfragment TeamMarketingProfileSlugForm_form_agentMarketingProfile on TeamMarketingProfile {\n  urlDetails {\n    baseUrl\n    slug\n  }\n  publicUrl\n}\n"
  }
};
})());

let wrap_response_updateTeamMarketingProfileSlug = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateTeamMarketingProfileSlug = unwrap_response_updateTeamMarketingProfileSlug;
exports.wrap_response_updateTeamMarketingProfileSlug = wrap_response_updateTeamMarketingProfileSlug;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
